import Vue from "vue";
import service from "@/store/services/profile-service";

let meRequestPending = null;

const state = {
  me: null,
};

const mutations = {
  SET_RESOURCE: (state, me) => {
    state.me = me;
  },
  SET_DASHBOARD_WIDGET_FOLDED: (state, { widget, folded }) => {
    if (!state.me) {
      return;
    }
    const preferences = state.me.ui_preferences || {};
    const foldedWidgets = (preferences.dashboard_folded_widgets || []).filter(
      (key) => key !== widget
    );
    if (folded) {
      foldedWidgets.push(widget);
    }
    // Only this attribute is replaced: swapping `me` would wake every watcher of
    // the profile for a display choice.
    Vue.set(state.me, "ui_preferences", {
      ...preferences,
      dashboard_folded_widgets: foldedWidgets,
    });
  },
};

const actions = {
  me({ commit, dispatch }, params) {
    // Prevent multiple concurrent /me requests
    if (meRequestPending) {
      return meRequestPending;
    }
    meRequestPending = service.get(params).then((profile) => {
      commit("SET_RESOURCE", profile.list);
      meRequestPending = null;
    }).catch((error) => {
      meRequestPending = null;
      throw error;
    });
    return meRequestPending;
  },

  update({ commit, dispatch }, params) {
    return service.update(params).then((profile) => {
      commit("SET_RESOURCE", profile);
    });
  },

  /**
   * Applied at once so the click feels instant, put back if the save fails.
   * The server's answer is not applied: with quick clicks an older answer could
   * arrive last and undo a newer fold.
   */
  foldDashboardWidget({ commit, getters }, { widget, folded }) {
    const wasFolded = getters.foldedDashboardWidgets.includes(widget);
    commit("SET_DASHBOARD_WIDGET_FOLDED", { widget, folded });
    return service.foldDashboardWidget(widget, folded).catch((error) => {
      commit("SET_DASHBOARD_WIDGET_FOLDED", { widget, folded: wasFolded });
      throw error;
    });
  },

  toggle2FA({ commit, dispatch }) {
    return service.toggle2FA().then((profile) => {
      commit("SET_RESOURCE", profile);
      return profile;
    });
  },
};

const getters = {
  me: (state) => state.me,
  foldedDashboardWidgets: (state) =>
    state.me?.ui_preferences?.dashboard_folded_widgets ?? [],
};

const profile = {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};

export default profile;
